import { BaasRemarkType } from './baas-remark.type';

export const _BAAS_REMARK_MAPPINGS: Record<BaasRemarkType, { class: string; color: string }> = {
    blocking: { class: 'fa-times-circle', color: 'error' },
    important: { class: 'fa-exclamation-circle', color: 'warning' },
    info: { class: 'fa-info-circle', color: 'info' }
} as const;
